import { en } from './lang/i18n.en';
import { zhCN } from './lang/i18n.zhCN';
const Language = {
  en,
  zhCN,
};

export default Language;
